module.exports = __webpack_public_path__ + "img/sukha.ec08aed8.png";